import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';

export default function isNavigable(messageBus: SDKMessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('isNavigable')) {
        return;
    }

    return (featureName: string, moduleName?: string): Promise<boolean> => {
        return messageBus
            .sendRequest<{ navigable: boolean }>(
                'isNavigable',
                Maybe.just(JSON.stringify({ featureName, moduleName }))
            )
            .then(response => response.value.navigable);
    };
}
